module.exports = __webpack_public_path__ + "img/MASTER_LOCAL.47800bc2.svg";